import { CollectionPageStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { storyblokEditable, type SbBlokData } from "@storyblok/js";
import clsx from "clsx";
import dynamic from "next/dynamic";
import styles from "./collection-page.module.css";

const BackgroundColorChange = dynamic(
  () => import("./ClientBackgroundColorChange")
);

const CollectionPage = ({
  blok,
  preview,
}: {
  blok: CollectionPageStoryblok;
  preview: boolean;
}) => {
  const Title = () =>
    !blok?.Title ? null : (
      <h1 className={clsx(styles.hero__heading, "blok-big-title")}>
        {blok.Title}
      </h1>
    );
  const Subtitle = () =>
    !blok?.shortDescription ? null : (
      <h2 className={clsx("blok-subtitle", styles.hero__subtitle)}>
        {blok.shortDescription}
      </h2>
    );

  return (
    <main
      key={blok._uid}
      {...storyblokEditable(blok as unknown as SbBlokData)}
      className="collection-page"
    >
      <BackgroundColorChange
        color={
          typeof blok.backgroundColor === "number"
            ? `#${blok.backgroundColor}`
            : (blok.backgroundColor ?? "var(--color-background)")
        }
      />
      <div data-layout="blok" className={styles.hero}>
        <Title />
        <Subtitle />
      </div>

      {blok.content?.map((currentBlok) => (
        <StoryblokComponent
          preview={preview}
          blok={currentBlok}
          key={"current-blok--" + currentBlok._uid}
        />
      ))}
    </main>
  );
};

export default CollectionPage;
